module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm5_m.fa66b961cc9cad8677933032fe8af58c.png";